import { useContext, useEffect, useState } from "react";
import { userService } from "../Services/userService";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../Contexts/UserContext";

const ResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const {openLoginModal} = useContext(UserContext);
    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [reEnterPassword, setReEnterPassword] = useState('');
    const [userMgs, setUserMgs] = useState('');

    useEffect(()=>{
        if (searchParams.has('code')) {
            setToken(searchParams.get('code'));
        }
        
    }, []);

    const resetPassword = (e) => {
        e.preventDefault();
        setUserMgs('');
        if (newPassword != reEnterPassword) {
            setUserMgs('Passwords didn\'t match');
        }
        else {
            let request = {
                token: token,
                password: newPassword
            }
            userService.resetPassword(request).then(res => {
                if (res.message == "InvalidToken") {
                    setUserMgs('Reset Password Link Expired. Try again.');
                }
                else {
                    toast.success('Password Reset Successfully');
                    navigate("/");
                    openLoginModal(true);
                }
            }).catch(err => {
                toast.error('Failed to Reset Password. Try Again !');
            });
        }
    }

    return (
        <div className="page-body reset-password">
            <form onSubmit={resetPassword} className="reset-pwd-form">
                <h4><center>Reset Password</center></h4><br/>
                <div className='form-group'>
                    <label htmlFor='new-password' className='form-label'>New Password : </label>
                    <input type="password" className="form-control" minlength="8" required value={newPassword} onInput={e => setNewPassword(e.target.value)}/>

                    <label htmlFor='reenter-new-password' className='form-label'>Re-enter New Password : </label>
                    <input type="password" className="form-control" required value={reEnterPassword} onInput={e => setReEnterPassword(e.target.value)}/>

                    <div className='user-mgs'><span>{userMgs}</span></div>
                </div>
                <div className='form-group reset-pwd-btn'>
                    <input type="submit" className="btn btn-primary" value="Reset Password"/>
                </div>
            </form>
        </div>
        
    );
}

export default ResetPassword;